import $ from "jquery";
var BuyLocation = /** @class */ (function () {
    function BuyLocation() {
        var _this = this;
        this.input = $(".js-search-input");
        this.hiddenInput = $("[name=place_id]");
        this.form = $("form");
        if (this.input.length) {
            this.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
            this.autocompleteService = new window.google.maps.places.AutocompleteService();
            new window.google.maps.places.SearchBox(this.input[0]);
            this.input.on("change", function () {
                _this.form.removeClass("error");
                _this.hiddenInput.val("");
            });
            this.form.on("submit", function () {
                if (_this.hiddenInput.val() == "") {
                    var searchString = _this.input.val();
                    if (searchString == "")
                        return false;
                    _this.getPlaceIdFromSearchString(searchString);
                    return false;
                }
            });
        }
    }
    BuyLocation.prototype.getPlaceIdFromSearchString = function (search) {
        var _this = this;
        this.autocompleteService.getPlacePredictions({
            input: search,
            sessionToken: this.sessionToken
        }, function (places, status) {
            if (places && places[0]) {
                _this.hiddenInput.val(places[0].place_id);
                _this.form.submit();
            }
            else {
                _this.form.addClass("error");
            }
        });
    };
    return BuyLocation;
}());
export { BuyLocation };
